import { render, staticRenderFns } from "./HelpDocuments.vue?vue&type=template&id=5c3f9010&scoped=true"
import script from "./HelpDocuments.vue?vue&type=script&lang=ts"
export * from "./HelpDocuments.vue?vue&type=script&lang=ts"
import style0 from "./HelpDocuments.vue?vue&type=style&index=0&id=5c3f9010&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f9010",
  null
  
)

export default component.exports